import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const ProductCopyValue = z.string();
export const ProductCopyTokenData = tokenAliasOrValue(ProductCopyValue);
